import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/* ═══════════════════════════════════════════════════════════════
   PINCODE RATES
   ═══════════════════════════════════════════════════════════════ */

export const createPincodeRate = (data) =>
  axiosInstance.post("/transport-pincode-rates/create", data).then((r) => r.data);
export const getAllPincodeRates = (params = {}) =>
  axiosInstance.get("/transport-pincode-rates/all", { params }).then((r) => r.data);
export const getPincodeRateById = (id) =>
  axiosInstance.get(`/transport-pincode-rates/${id}`).then((r) => r.data);
export const lookupTransportCharge = (params) =>
  axiosInstance.get("/transport-pincode-rates/lookup", { params }).then((r) => r.data);
export const updatePincodeRate = (id, data) =>
  axiosInstance.put(`/transport-pincode-rates/update/${id}`, data).then((r) => r.data);
export const deletePincodeRate = (id) =>
  axiosInstance.delete(`/transport-pincode-rates/delete/${id}`).then((r) => r.data);

export const createPincodeRatePortal = (data) =>
  axiosInstance.post("/transport-pincode-rate-portal/create", data).then((r) => r.data);
export const getAllPincodeRatesPortal = (params = {}) =>
  axiosInstance.get("/transport-pincode-rate-portal/all", { params }).then((r) => r.data);
export const getPincodeRateByIdPortal = (id) =>
  axiosInstance.get(`/transport-pincode-rate-portal/${id}`).then((r) => r.data);
export const lookupTransportChargePortal = (params) =>
  axiosInstance.get("/transport-pincode-rate-portal/lookup", { params }).then((r) => r.data);
export const updatePincodeRatePortal = (id, data) =>
  axiosInstance.put(`/transport-pincode-rate-portal/update/${id}`, data).then((r) => r.data);
export const deletePincodeRatePortal = (id) =>
  axiosInstance.delete(`/transport-pincode-rate-portal/delete/${id}`).then((r) => r.data);

/* ═══════════════════════════════════════════════════════════════
   VEHICLES
   ═══════════════════════════════════════════════════════════════ */

export const createVehicle = (data) =>
  axiosInstance.post("/transport-vehicles/create", data).then((r) => r.data);
export const getAllVehicles = (params = {}) =>
  axiosInstance.get("/transport-vehicles/all", { params }).then((r) => r.data);
export const getVehicleById = (id, params = {}) =>
  axiosInstance.get(`/transport-vehicles/${id}`, { params }).then((r) => r.data);
export const getVehicleCapacity = (id, params) =>
  axiosInstance.get(`/transport-vehicles/${id}/capacity`, { params }).then((r) => r.data);
export const getAvailableVehicles = (params) =>
  axiosInstance.get("/transport-vehicles/available", { params }).then((r) => r.data);
export const updateVehicle = (id, data) =>
  axiosInstance.put(`/transport-vehicles/update/${id}`, data).then((r) => r.data);
export const deleteVehicle = (id) =>
  axiosInstance.delete(`/transport-vehicles/delete/${id}`).then((r) => r.data);

export const createVehiclePortal = (data) =>
  axiosInstance.post("/transport-vehicle-portal/create", data).then((r) => r.data);
export const getAllVehiclesPortal = (params = {}) =>
  axiosInstance.get("/transport-vehicle-portal/all", { params }).then((r) => r.data);
export const getVehicleByIdPortal = (id, params = {}) =>
  axiosInstance.get(`/transport-vehicle-portal/${id}`, { params }).then((r) => r.data);
export const getVehicleCapacityPortal = (id, params) =>
  axiosInstance.get(`/transport-vehicle-portal/${id}/capacity`, { params }).then((r) => r.data);
export const getAvailableVehiclesPortal = (params) =>
  axiosInstance.get("/transport-vehicle-portal/available", { params }).then((r) => r.data);
export const updateVehiclePortal = (id, data) =>
  axiosInstance.put(`/transport-vehicle-portal/update/${id}`, data).then((r) => r.data);
export const deleteVehiclePortal = (id) =>
  axiosInstance.delete(`/transport-vehicle-portal/delete/${id}`).then((r) => r.data);

/* ═══════════════════════════════════════════════════════════════
   STUDENT ASSIGNMENTS
   ═══════════════════════════════════════════════════════════════ */

export const createAssignment = (data) =>
  axiosInstance.post("/student-transport-assignments/create", data).then((r) => r.data);
export const getAllAssignments = (params = {}) =>
  axiosInstance.get("/student-transport-assignments/all", { params }).then((r) => r.data);
export const getAssignmentById = (id) =>
  axiosInstance.get(`/student-transport-assignments/${id}`).then((r) => r.data);
export const getAssignmentsByStudent = (studentId, params = {}) =>
  axiosInstance
    .get(`/student-transport-assignments/student/${studentId}`, { params })
    .then((r) => r.data);
export const getTransportChargeForStudent = (params) =>
  axiosInstance.get("/student-transport-assignments/charge", { params }).then((r) => r.data);
export const updateAssignment = (id, data) =>
  axiosInstance.put(`/student-transport-assignments/update/${id}`, data).then((r) => r.data);
export const deactivateAssignment = (id) =>
  axiosInstance.patch(`/student-transport-assignments/deactivate/${id}`).then((r) => r.data);
export const deleteAssignment = (id) =>
  axiosInstance.delete(`/student-transport-assignments/delete/${id}`).then((r) => r.data);

export const createAssignmentPortal = (data) =>
  axiosInstance.post("/student-transport-assignment-portal/create", data).then((r) => r.data);
export const getAllAssignmentsPortal = (params = {}) =>
  axiosInstance.get("/student-transport-assignment-portal/all", { params }).then((r) => r.data);
export const getAssignmentByIdPortal = (id) =>
  axiosInstance.get(`/student-transport-assignment-portal/${id}`).then((r) => r.data);
export const getAssignmentsByStudentPortal = (studentId, params = {}) =>
  axiosInstance
    .get(`/student-transport-assignment-portal/student/${studentId}`, { params })
    .then((r) => r.data);
export const getTransportChargeForStudentPortal = (params) =>
  axiosInstance
    .get("/student-transport-assignment-portal/charge", { params })
    .then((r) => r.data);
export const updateAssignmentPortal = (id, data) =>
  axiosInstance
    .put(`/student-transport-assignment-portal/update/${id}`, data)
    .then((r) => r.data);
export const deactivateAssignmentPortal = (id) =>
  axiosInstance
    .patch(`/student-transport-assignment-portal/deactivate/${id}`)
    .then((r) => r.data);
export const deleteAssignmentPortal = (id) =>
  axiosInstance
    .delete(`/student-transport-assignment-portal/delete/${id}`)
    .then((r) => r.data);

/* ═══════════════════════════════════════════════════════════════
   SUPPORTING LOOKUPS (classes / sections / students / years)
   Uses existing school endpoints
   ═══════════════════════════════════════════════════════════════ */

export const getAcademicYears = () =>
  axiosInstance.get("/academic-years/all").then((r) => r.data);
export const getAcademicYearsPortal = () =>
  axiosInstance.get("/academic-year-portal/all").then((r) => r.data);

export const getClasses = () =>
  axiosInstance.get("/classes/all").then((r) => r.data);
export const getClassesPortal = () =>
  axiosInstance.get("/classes/all").then((r) => r.data);

export const getSections = (params = {}) =>
  axiosInstance.get("/sections/all", { params }).then((r) => r.data);

export const getStudents = (params = {}) =>
  axiosInstance.get("/students/all", { params }).then((r) => r.data);
export const getStudentsPortal = (params = {}) =>
  axiosInstance.get("/admin-students/all", { params }).then((r) => r.data);
